import { CheckMark } from '@lyearn/icons';
import { DatabaseFieldTypeEnum } from '@/types/schema';

export const SelectFieldStaticConfig = {
  Icon: CheckMark,
  type: DatabaseFieldTypeEnum.Select,
  labelKey: 'Common:Actions.Select',
};
